<div class="row">
    <div class="col-12 header-img">
        <div class="row">
            <div class="col-4 green-panel">
                <div class="row justify-content-end">
                        <h1 class="col-8 ">BOUGEZ <h3>Avec Clem'</h3></h1>
                    <div class="col-12">
                        <div class="row">
                                <div class="col-6">
                                        <button>GOOGLE</button>
                                    </div>
                                    <div class="col-6">
                                        <button>APPLE</button>
                                    </div>                      
                        </div>
                    </div>
                </div>
            </div>
            <div class="clo-8 img-panel">
                <div class="row">
                    <h1>ELECTRIQUE !</h1>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="row">
  <div class="col-12">
      <div class="row head-img align-items-end d-none d-lg-block  " style="background-image:url('assets/offline-img/IMG_20190606_171720.jpg');">
        <div class="  col-12 head-img-info ">
          <div class="row align-items-end">
            <div class="col-12 ">
              <div class="row justify-content-md-center">
                  <h1 class="col-sm-8">Clem' autopartage</h1>
                  <h5  class="col-sm-8">Je choisis la simplicité et la sérénité</h5>
                  <div class="col-sm-8">
                    <div class="row justify-content-md-center">
                        <div class="col-">
                            <button mat-raised-button color="primary">Réserver une voiture</button>                    
                        </div>
      
                    </div>
                  </div>
  
              </div>
            </div>
          </div>
        
        </div>
      </div>
      <div class=" col-12 d-lg-none ">
          <div class="row justify-content-md-center head-img-info-mobile ">
            <div class="col-12 img-mobile">
                <img src="assets/offline-img/IMG_20190606_171720.jpg"/>
            </div>
              <h1 class="col-sm-8">Clem' autopartage</h1>
              <h5  class="col-sm-8">Je choisis la simplicité et la sérénité</h5>
              <div class="col-sm-12">
                <div class="row justify-content-md-center">
                    <div class="col">
                        <button mat-raised-button color="primary">Réserver une voiture</button>                    
                    </div>
  
                </div>
              </div>

          </div>
      </div>      
  </div>
</div> -->
